export default {
  methods: {
    isRecoV2Enabled (company) {
      return this.$permission.hasRoute('AdminRecoV2Settings') && company.useRecommendationAlgorithm
    }
  }
}
